import React, { useContext } from 'react';
import { Col, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import Text from 'antd/lib/typography/Text';
import { LanguageContext } from 'contexts/LanguageContext';

interface CampaignSavedProps {
	campaignName: string;
}

export default function CampaignSaved(props: CampaignSavedProps) {
	const { dictionary } = useContext(LanguageContext);

	return (
		<>
			<Row style={{ height: 100, paddingTop: '2em' }}>
				<Title level={2}>
					<Text type="gray-9">{dictionary.campaign_ready_title}</Text>
				</Title>
			</Row>
		</>
	);
}
